import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  ecatDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-statement-folder.controller';
import directive from './attach-statement-folder.directive';
import attachStatementDocument from '../attachStatementDocument';

export default angular.module('app.components.advisory.ecat.attachStatementFolder', [
  alerts,
  ecatDataService,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  attachStatementDocument
])
  .directive('ecatAttachStatementFolder', directive)
  .controller('AttachStatementFolderController', controller)
  .name;

console.log('app.components.advisory.ecat.attachStatementFolder created');
